import Actions from '../../odata/actions';

const actions = new Actions('orgTaxRate', 'orgTaxRates');

export default actions;
